import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Prospeccion } from '../../models/prospeccion';
import { GestionclientesService } from '../../gestionclientes.service';
import swal from 'sweetalert2';
import { ModificarmodalComponent } from '../../modificarmodal/modificarmodal.component';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-modal-registro-seguimiento',
    standalone: true,
    templateUrl: './modal-registro-seguimiento.component.html',
    styleUrls: ['./modal-registro-seguimiento.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, NgFor, MatOption, MatButton]
})
export class ModalRegistroSeguimientoComponent implements OnInit{
  datosform: FormGroup;
  objetoProspecto: Prospeccion;
  esConsulta:boolean = false;
  estatusOptions = ['ABIERTO', 'CERRADO'];
  clientes: Cliente[];
  
  constructor(
    public dialogRef: MatDialogRef<ModalRegistroSeguimientoComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private proyectosService: ProyectosService,
    private formbuilder: FormBuilder,
    private serviceCliente: GestionclientesService
  ) { }

ngOnInit() {
  this.datosform = this.formbuilder.group({
    causa: ['', Validators.required],
    estatus: ['', Validators.required]
  });
  if (this.data.id !== null && this.data.id !== undefined) {
    this.consultaClientes();
    this.esConsulta = true;
    this.objetoProspecto = this.data as Prospeccion;
    this.objetoProspecto.id = this.data.id;
  } else {
    this.objetoProspecto = new Prospeccion();
  }
}

consultaClientes(): void {
  this.proyectosService
    .obtenerProspecto(new Cliente())
    .subscribe(response => {
      if (response !== null && response !== undefined) {
        this.clientes = response;
      }
    });
}

guardaProspecto(): void {
  this.serviceCliente.guardarProspecto(this.objetoProspecto).subscribe(
    (respuesta) => {
 
      if (this.objetoProspecto.estatus === 'CERRADO') {
        swal.fire({
          text: 'Prospecto registrado exitosamente. ¿Es un cliente?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const clienteEncontrado = this.clientes.find(cliente => cliente.id === this.objetoProspecto.cliente);
            
            if (clienteEncontrado) {
              this.dialogRef.close();
              this.update(clienteEncontrado);
            } else {
              console.error('Cliente no encontrado.');
              swal.fire({
                text: 'No se encontró el cliente asociado.',
                icon: 'error',
                buttonsStyling: false,
                customClass: {
                  confirmButton: 'btn btn-danger',
                }
              });
              this.dialogRef.close();
            }
          } else {
            this.dialogRef.close();
          }
        });
      } else {
        swal.fire({
          text: 'Prospecto registrado exitosamente',
          icon: 'success',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
          }
        }).then(() => {
          this.dialogRef.close();
        });
      }
    }
  );
}

  update(cliente): void {
    this.dialog.open(ModificarmodalComponent, {
      maxHeight: '81vh',
      width: '1200px',
      panelClass: 'custom-modalbox',
      data: cliente
  });
}

onNoClick(): void {
  this.dialogRef.close();
}
}
